import type { ReactNode } from 'react';

export type StatusTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export interface StatusPillProps {
  tone: StatusTone;
  children: ReactNode;
}

const toneToColor: Record<StatusTone, string> = {
  success: 'var(--color-success)',
  warning: 'var(--color-warning)',
  danger:  'var(--color-danger)',
  info:    'var(--color-info)',
  neutral: 'var(--color-text-secondary)',
};

export function StatusPill({ tone, children }: StatusPillProps) {
  const color = toneToColor[tone];
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px var(--spacing-2)',
        fontSize: 'var(--font-size-xs)',
        borderRadius: 'var(--radius-full)',
        color,
        border: `1px solid ${color}`,
        background: 'var(--color-surface-background)',
      }}
    >
      {children}
    </span>
  );
}
